import PlatformError from "../PlatformError";

export default new PlatformError("ERROR", "Your screen height was determined to be too low for this study", "Screenout", "User failed screen height check", "app.prestart.screenheight")
